import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useFormContext } from 'app/components/core/Form';
import { ToggleSwitch } from 'app/components/core/ToggleSwitch';
import { SlackChannelSelectContainer } from 'app/components/features/SlackNotifications/SlackChannelSelect';
import { DialogChapter, StringSummary } from 'app/components/features/DialogWithChapters';

export function SlackNotificationsField() {
    const { t } = useTranslation();
    const context = useFormContext();
    const notifications = context.getFieldValue('notifications');
    const isEnabled = context.getFieldValue('notifications.enabled');
    const summary = useMemo(
        () => <StringSummary value={isEnabled ? t('common:enabled') : t('common:disabled')} />,
        [t, isEnabled]
    );

    return (
        <DialogChapter
            label={t('jobs:dialogs.environment.notifications')}
            summary={summary}
            isOptional>
            <Field
                component={ToggleSwitch}
                label={t('common:enable')}
                name="notifications.enabled"
            />
            {notifications.enabled && (
                <Field
                    component={SlackChannelSelectContainer}
                    name="notifications.slackChannelId"
                    label={t('jobs:dialogs.environment.channel')}
                />
            )}
        </DialogChapter>
    );
}
